import React, { Component } from "react";
import { withAppState } from "../../state";
import {
  StaticEpgStyled,
  TimeStyled,
  DateStyled,
  NowStyled,
  NextStyled,
  LaterStyled,
  EpgContainer,
  TimeTextStyled,
  LayoutEmptyStyledEPG
} from "./viewStyles/Styled";
import StaticEpg from "./StaticEpg";
import { Text } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import { getSlotTimeInHours, reduceDataForStaticView, EVENT_STATUS } from "../../utils/epgUtil";

class StaticView extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      epgStaticData: []
    };
  }

  componentDidMount() {
    if (this.props.data) {
      this.cropStaticEpgData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentCategory !== this.props.currentCategory) {
      this.cropStaticEpgData();
    }
  }

  setCurrentHourOnTimeSlot() {
    const initialEvents = this.state.epgStaticData[0]?.data[0]?.events;
    const liveInitialEvent = initialEvents ? initialEvents.filter(item => item.status === EVENT_STATUS.live) : "";
    this.setState({
      currentHour: getSlotTimeInHours(liveInitialEvent[0]?.tsStart)
    });
  }

  cropStaticEpgData() {
    const newStaticEpgData = reduceDataForStaticView([...this.props.data]);
    this.setState({ epgStaticData: newStaticEpgData }, () => {
      this.setCurrentHourOnTimeSlot();
    });
  }

  render() {
    const {
      currentDate,
      onChange,
      currentView,
      changeView,
      changeViewRowIndex,
      visibleRows,
      visibleCat,
      currentRowIndex,
      categoryIndex,
      currentVideoMetaData,
      isFullScreen,
      backToCetaogryColIndex,
      wheelState,
      actions,
      onUpdateWheelState,
      onClickEpgSlots
    } = this.props;
    const { currentHour, epgStaticData } = this.state;
    const direction = i18n.getDirection();
    return (
      <StaticEpgStyled>
        <DateStyled direction={direction}>{currentDate}</DateStyled>
        <TimeStyled direction={direction} view={"static"}>
          <NowStyled direction={direction}>
            <TimeTextStyled direction={direction}>
              {currentHour
                ? `${i18n.get("pages.livePage.time.now")} - ${currentHour}`
                : `${i18n.get("pages.livePage.time.now")}`}
            </TimeTextStyled>
          </NowStyled>
          <NextStyled direction={direction}>
            <TimeTextStyled direction={direction}>{i18n.get("pages.livePage.time.next")}</TimeTextStyled>
          </NextStyled>
          <LaterStyled direction={direction}>
            <TimeTextStyled direction={direction}>{i18n.get("pages.livePage.time.later")}</TimeTextStyled>
          </LaterStyled>
        </TimeStyled>
        <EpgContainer>
          {epgStaticData.length !== 0 ? (
            <StaticEpg
              staticData={epgStaticData}
              onChange={onChange}
              currentView={currentView}
              changeView={changeView}
              isFullScreen={isFullScreen}
              backToCetaogryColIndex={backToCetaogryColIndex}
              changeViewRowIndex={changeViewRowIndex}
              visibleRows={visibleRows}
              visibleCat={visibleCat}
              currentRowIndex={currentRowIndex}
              categoryIndex={categoryIndex}
              currentVideoMetaData={currentVideoMetaData}
              wheelState={wheelState}
              actions={actions}
              onUpdateWheelState={onUpdateWheelState}
              onClickEpgSlots = {onClickEpgSlots}
            />
          ) : (
            <LayoutEmptyStyledEPG>
              <strong>
                <Text text={i18n.get("pages.livePage.noData.emptyDataMsg")} />
              </strong>
              <Text text={i18n.get("pages.livePage.noData.emptyDataSubMsg")} />
            </LayoutEmptyStyledEPG>
          )}
        </EpgContainer>
      </StaticEpgStyled>
    );
  }
}
export default withAppState(StaticView);
